//* 지망생 계정 정지 관련 API
// 2025.12.05
// 희문

import * as BaseApi from "api/Base.api";
import * as UserInterface from "interfaces/User.interface";

const BASE_URL = "/student/v2/block";

//* Response Interfaces
export interface IGetBlockInfoResponse {
  blockInfo: UserInterface.IBlockObj;
}

export interface IGetResolveRequestListResponse {
  resolveRequestList: UserInterface.IBlockResolveRequestObj[];
}

export interface ICreateResolveRequestParams {
  reason: string;
}

export interface ICreateResolveRequestResponse {
  id: number;
  adminUserBlockId: number;
  reason: string;
  createdAt: string;
}

//* 차단 정보 요청
// 2025.12.05
// 희문
// 지망생의 계정 정지 정보를 조회합니다.
export const getBlockInfo = async () => {
  const url = `${BASE_URL}/info`;
  return await BaseApi.get(url);
};

//* 계정 차단 해제 목록 요청
// 2025.12.05
// 희문
// 지망생의 계정 차단 해제 요청 목록을 조회합니다.
export const getResolveRequestList = async () => {
  const url = `${BASE_URL}/resolve-request`;
  return await BaseApi.get(url);
};

//* 계정 차단 해제 요청 생성
// 2025.12.05
// 희문
// 지망생이 계정 차단 해제를 요청합니다.
export const createResolveRequest = async (params: ICreateResolveRequestParams) => {
  const url = `${BASE_URL}/resolve-request`;
  return await BaseApi.post(url, params);
};

